export default __webpack_public_path__ + "static/media/Unlock-II.0ed552cf.png";